import GenericModel from '../../generic-model';
import { SignPlacementPriceType } from './sign-placement-price-type';
import BoardType from '../../product/board/board-type';
import IPBoardPlacementType from '../../product/ip-board/ip-board-placement-type';
import { SignMeasurements } from '../enums/sign-measurements';

export class SignPlacementPrice extends GenericModel {
  signPlacementPriceType?: SignPlacementPriceType;
  signMeasurements?: SignMeasurements;
  boardType?: BoardType;
  placementType?: IPBoardPlacementType;

  placementMinuteBudget?: number;
  repoMinuteBudget?: number;

  priceAAA?: number;
  priceAA?: number;
  priceA?: number;
  priceB?: number;
  priceC?: number;

  // helper variables for placement price table
  editing?: boolean;
  designUrl?: string;
}
